<template>
  <div class="courses-container">
    <div class=" main-view">
      <div class="search-course  mt-20">
        <div
          class="flex justify-center px-15"
          style="width:100%; text-align:center"
        >
          <SearchNavBar @change-select-courses="handleChangeSearchCourses" />
        </div>
      </div>
    </div>
    <div v-loading="loadingData" class="container">
      <div style="min-height: 500px;" class="list-courses w-100">
        <CardCourses
          v-for="(item, index) in listData"
          :key="index"
          :object-data="item"
          :my-courses="myCourses"
          class="w-100 mb-20"
        />
        <div class="flex justify-center" v-if="listData.length === 0">
          <el-empty
            description="No course information"
            :image-size="200"
          ></el-empty>
        </div>
        <!-- <div style="margin-top: 50px;" class="mt-20 text-center">
          <Pagination
            v-show="total > 0 && listData.length > 0"
            :total="total"
            :limit.sync="query.limit"
            :page.sync="query.page"
            @pagination="onGetList"
          />
        </div> -->
        <div ref="end-location" />
        <infinite-loading
          ref="infiniteLoading"
          :identifier="infiniteId"
          @infinite="infiniteHandler"
        >
          <div slot="no-results"></div>
          <div slot="no-more"></div>
        </infinite-loading>
      </div>
    </div>
  </div>
</template>
<script>
import SearchNavBar from "@/views/components/search/SearchNavBar.vue";
import CardCourses from "@/views/components/card/CardCourses.vue";
import Pagination from "@/components/Pagination.vue";
import CoursesResource from "../../api/courses";
export default {
  name: "courses",
  props: {},
  components: {
    SearchNavBar,
    CardCourses
    // Pagination
  },
  created() {
    this.onGetList();

    console.log(this.$route);
  },
  data() {
    return {
      icons: {},
      teeTimeLoading: false,
      position: 0,
      infiniteId: +new Date(),
      emptyDes:
        this.$route.name === "MyCourses"
          ? "No course information"
          : "No course information or all courses have been purchased",
      myCourses: this.$route.name === "MyCourses",
      total: 0,
      loadingData: false,
      query: {
        page: 1,
        limit: 10,
        keyword: this.$route.params.keyword,
        is_purchase: this.$route.name === "MyCourses" ? 1 : null,
        course_topic_id: this.$route.params.course_topic_id
      },
      listData: []
    };
  },
  watch: {
    $route(value) {
      console.log(value);
      delete this.query.keyword;
      if (value.name === "MyCourses") {
        this.emptyDes = "No course information";
        this.query.is_purchase = 1;
        this.myCourses = true;
      } else {
        this.emptyDes =
          "No course information or all courses have been purchased";
        this.myCourses = false;
        this.query.is_purchase = null;
      }
      this.resetData();
      this.onGetList();
    }
  },

  methods: {
    handleFilter() {
      delete this.query.keyword;
      this.onGetList();
    },
    onGetList() {
      this.loadingData = true;
      if (this.$route.params.course_topic_id) {
        this.query.course_topic_id = this.$route.params.course_topic_id;
      } else {
        delete this.query.course_topic_id;
      }
      CoursesResource.Lists(this.query)
        .then(res => {
          const { error_code, data } = res;
          if (error_code === 0) {
            this.total = data.total;
            this.listData = data.data;
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    async infiniteHandler($state) {
      console.log("$state_________", $state);
      if (!this.teeTimeLoading) {
        this.query.page += 1;
        this.teeTimeLoading = true;

        if (this.$route.params.course_topic_id) {
          this.query.course_topic_id = this.$route.params.course_topic_id;
        } else {
          delete this.query.course_topic_id;
        }
        const { error_code, data } = await CoursesResource.Lists(this.query);

        console.log("data______", data);
        this.teeTimeLoading = false;

        if (error_code === 0) {
          const newPosition =
            this.$refs["end-location"].getBoundingClientRect().top +
            window.pageYOffset;

          if (this.position) window.scrollTo(0, this.position);

          this.position = newPosition;
          this.total = data.total;
          this.listData = [...this.listData, ...data.data];
        }
        if (data.data.length < 10) {
          $state.complete();
        } else {
          $state.loaded();
        }
      }
    },
    handleChangeSearchCourses(val) {
      this.resetData();
      if (val) {
        this.query.keyword = val;
      } else {
        delete this.query.keyword;
      }

      this.onGetList();
    },
    resetData() {
      this.query.page = 1;
      this.position = 0;
      this.infiniteId = +new Date();
    }
  }
};

//  <!-- background: #f5f9ff; -->
</script>
<style scoped>
.search-course {
  padding: 3px 0;
}

.btn-search {
  margin-top: 2px;
  margin-left: 12px;
  border: 1px solid #035ae0;
  right: 0;
  color: #035ae0;
  border-radius: 50px;
  font-size: 12px;
  padding: 0px 20px;
  height: 35px;
}
.courses-container {
}
.main-view {
  padding-top: 100px;
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .main-view {
    padding-top: 70px;
  }
}
</style>
